import styled from "styled-components";
import Buttons from "../../../components/Button/button.component";
import { colors } from "../../../theme/color";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";

const UserTextHead = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

const UserTextSubHeader = styled.div``;

const UserTextMainText = styled.div`
  font-weight: 500;
  font-size: 26px;
  letter-spacing: 0.5px;
  color: #09005b;
  @media screen and (max-width: 767px) {
    font-size: 1.125rem;
  }
`;

export const UserTextSubText = styled.h6`
  margin-top: 15px;
  font-size: 14px;
  font-weight: 400;
  color: #5e5e5e;
`;

const ButtonHead = styled.div`
  /* width: 20%; */
  /* @media screen and (min-width: 430px) {
    width: 65%;
    flex-direction: column;
  }

  @media screen and (min-width: 390px) {
    width: 70%;
    margin-top: 15px;
  }

  @media screen and (min-width: 360px) {
    width: 65%;
    margin-top: 15px;
  } */
`;

const UserTextHeader = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/dashboard/add-users");
  };
  return (
    <div
      style={{
        width: "76vw",
        paddingTop: "30px",
        paddingBottom: "10px",
        paddingLeft: "20px",
      }}
    >
      <UserTextHead>
        <UserTextSubHeader>
          <UserTextMainText>User Management</UserTextMainText>
          <UserTextSubText>
            Manage all users access and permissions within your accounts.
          </UserTextSubText>
        </UserTextSubHeader>
        <ButtonHead>
          <Button
            id={""}
            type="button"
            onClick={handleClick}
            padding={"10px 30px"}
            title={"Add New User"}
            border="0.625rem"
            green
          />
        </ButtonHead>
      </UserTextHead>
    </div>
  );
};

export default UserTextHeader;
